
const digest = 'f428ade632b76988e25a11b8557e6832f97854b35e81574670c5ed55e061dab7';
const classes = {"wrapper":"_wrapper_1r8zf_1"};
const css = `._wrapper_1r8zf_1 {
  border-right: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  